module.exports = __webpack_public_path__ + "img/1461684197.a5c6cd80.jpg";